import {_BASIC_TRANSACTIONS,
        RESET_CONFIGURATION, 
        PURCHASE_SUCCESS, PURCHASE_SENT,
        PREAUTH_SENT, PREAUTH_SUCCESS,
        PREAUTH_COMPLETION_SENT, PREAUTH_COMPLETION_SUCCESS, PREAUTH_COMPLETION_FAIL,
        FORCE_POST_SENT, FORCE_POST_SUCCESS,
        PURCHASE_CORRECTION_SENT, PURCHASE_CORRECTION_SUCCESS, PURCHASE_CORRECTION_FAIL,
        REFUND_SENT, REFUND_SUCCESS, REFUND_FAIL,
        INDEPENDENT_REFUND_SENT, INDEPENDENT_REFUND_SUCCESS,
        CARD_VERIFICATION_SENT, CARD_VERIFICATION_SUCCESS,
        BATCH_CLOSE_SENT, BATCH_CLOSE_SUCCESS,
        OPEN_TOTALS_SENT, OPEN_TOTALS_SUCCESS,
        UPDATE_STORE_ID,
        UPDATE_PAN,
        UPDATE_ORDER_ID,
        UPDATE_EXPDATE,
        UPDATE_CURRENCY,
        UPDATE_API_TOKEN,
        UPDATE_AMOUNT,
        UPDATE_TXN_NUMBER,
        UPDATE_ECR_NUMBER,
        CLEAR_HISTORY,
        UPDATE_ON_EDIT_ID,
    } from '../../actions/types'

const initialState = {
    prevSuccStep: 0, // the id of the most recent successful transaction (step)

    purchaseResponse: "No request has been made.",
    preAuthResponse: "No request has been made.",
    preAuthCompResponse: "No request has been made.",
    forcePostResponse: "No request has been made.",
    purchaseCorrectionResponse: "No request has been made.",
    refundResponse: "No request has been made.",
    independentRefundResponse: "No request has been made.",
    cardVerificationResponse: "No request has been made.",
    batchCloseResponse: "No request has been made.",
    openTotalsResponse: "No request has been made.",

    loading: false,

    purchaseSuccess: false,
    preAuthSuccess: false,
    preAuthCompSuccess: false,
    forcePostSuccess: false,
    purchaseCorrectionSuccess: false,
    refundSuccess: false,
    independentRefundSuccess: false,
    cardVerificationSuccess: false,
    batchCloseSuccess: false,
    openTotalsSuccess: false,

    config: {
        storeId: "store5",
        apiToken: "yesguy",
        orderId: "Test123456789",
        pan: "4242424242424242", //4606633870436092
        expdate: "2310",
        amount: "1.00",
        currency: "124",
        txnNumber: "none",
        ecrNumber: "66014842", //66013455
        onEditId: 'none'
    },

    history: []
}

// eslint-disable-next-line
export default function(state = initialState, action) {
    if(action.feature === _BASIC_TRANSACTIONS) {
        switch(action.type) {
            case UPDATE_AMOUNT:
                return { ...state, config: { ...state.config, amount: action.payload }}
            case UPDATE_API_TOKEN:
                return { ...state, config: { ...state.config, apiToken: action.payload }}
            case UPDATE_CURRENCY:
                return { ...state, config: { ...state.config, currency: action.payload }}
            case UPDATE_EXPDATE:
                return { ...state, config: { ...state.config, expdate: action.payload }}
            case UPDATE_ORDER_ID:
                return { ...state, config: { ...state.config, orderId: action.payload }}
            case UPDATE_PAN:
                return { ...state, config: { ...state.config, pan: action.payload }}
            case UPDATE_STORE_ID:
                return { ...state, config: { ...state.config, storeId: action.payload }}
            case UPDATE_TXN_NUMBER:
                return { ...state, config: { ...state.config, txnNumber: action.payload }}
            case UPDATE_ECR_NUMBER: 
                return { ...state, config: { ...state.config, ecrNumber: action.payload }}
            case UPDATE_ON_EDIT_ID:
                return { ...state, config: { ...state.config, onEditId: action.payload }}


            case PURCHASE_SENT:
                return { ...state, loading: true, purchaseSuccess: false, history: [] }
            case PURCHASE_SUCCESS:
                return { 
                    ...state, 
                    history: [1], 
                    purchaseResponse: action.payload, 
                    purchaseCorrectionResponse: "No request has been made.",
                    loading: false, 
                    purchaseSuccess: true, 
                    prevSuccStep: 1
                }

            case PREAUTH_SENT:
                return { ...state, loading: true, preAuthSuccess: false, history: [] }
            case PREAUTH_SUCCESS:
                return { 
                    ...state, 
                    history: [2], 
                    preAuthResponse: action.payload, 
                    loading: false, 
                    preAuthSuccess: true, 
                    preAuthCompSuccess: false, 
                    preAuthCompResponse: "No request has been made.", 
                    prevSuccStep: 2 
                }

            case PREAUTH_COMPLETION_SENT:
                return { ...state, loading: true, preAuthCompSuccess: false }
            case PREAUTH_COMPLETION_SUCCESS:
                return { 
                    ...state, 
                    history: [ ...state.history, 3], 
                    preAuthCompResponse: action.payload,
                    purchaseCorrectionResponse: "No request has been made.",
                    loading: false, 
                    preAuthCompSuccess: true, 
                    prevSuccStep: 3 
                }
            case PREAUTH_COMPLETION_FAIL:
                return { ...state, loading: false, preAuthCompResponse: action.payload }

            case FORCE_POST_SENT:
                return { ...state, loading: true, forcePostSuccess: false, history: [] }
            case FORCE_POST_SUCCESS:
                return { 
                    ...state, 
                    history: [4],
                    forcePostResponse: action.payload,
                    purchaseCorrectionResponse: "No request has been made.",
                    loading: false, 
                    forcePostSuccess: true, 
                    prevSuccStep: 4 
                }

            case PURCHASE_CORRECTION_SENT:
                return { ...state, loading: true, purchaseCorrectionSuccess: false }
            case PURCHASE_CORRECTION_SUCCESS:
                return { ...state, history: [ ...state.history, 5], purchaseCorrectionResponse: action.payload, loading: false, purchaseCorrectionSuccess: true, prevSuccStep: 5 }
            case PURCHASE_CORRECTION_FAIL:
                return { ...state, loading: false, purchaseCorrectionResponse: action.payload }

            case REFUND_SENT:
                return { ...state, loading: true, refundSuccess: false }
            case REFUND_SUCCESS:
                return { ...state, history: [ ...state.history, 6], refundResponse: action.payload, loading: false, refundSuccess: true, prevSuccStep: 6 }
            case REFUND_FAIL:
                return { ...state, loading: false, refundResponse: action.payload }

            case INDEPENDENT_REFUND_SENT:
                return { ...state, loading: true, independentRefundSuccess: false, history: [] }
            case INDEPENDENT_REFUND_SUCCESS:
                return { ...state, history: [7], independentRefundResponse: action.payload, loading: false, independentRefundSuccess: true, prevSuccStep: 7 }

            case CARD_VERIFICATION_SENT:
                return { ...state, loading: true, cardVerificationSuccess: false, history: [] }
            case CARD_VERIFICATION_SUCCESS:
                return { ...state, history: [8], cardVerificationResponse: action.payload, loading: false, cardVerificationSuccess: true, prevSuccStep: 8 }

            case BATCH_CLOSE_SENT:
                return { ...state, loading: true, batchCloseSuccess: false }
            case BATCH_CLOSE_SUCCESS:
                return { 
                    ...state, 
                    history: [ ...state.history, 9], 
                    batchCloseResponse: action.payload, 
                    refundResponse: "No request has been made.",
                    loading: false, 
                    batchCloseSuccess: true, 
                    prevSuccStep: 9 
                }

            case OPEN_TOTALS_SENT:
                return { ...state, loading: true, openTotalsSuccess: false }
            case OPEN_TOTALS_SUCCESS:
                return { ...state, history: [ ...state.history, 10], openTotalsResponse: action.payload, loading: false, openTotalsSuccess: true, prevSuccStep: 10 }
            
            case CLEAR_HISTORY:
                return { ...state, history: [],
                    prevSuccStep: 0,

                    purchaseResponse: "No request has been made.",
                    preAuthResponse: "No request has been made.",
                    preAuthCompResponse: "No request has been made.",
                    forcePostResponse: "No request has been made.",
                    purchaseCorrectionResponse: "No request has been made.",
                    refundResponse: "No request has been made.",
                    independentRefundResponse: "No request has been made.",
                    cardVerificationResponse: "No request has been made.",
                    batchCloseResponse: "No request has been made.",
                    openTotalsResponse: "No request has been made.",

                    purchaseSuccess: false,
                    preAuthSuccess: false,
                    preAuthCompSuccess: false,
                    forcePostSuccess: false,
                    purchaseCorrectionSuccess: false,
                    refundSuccess: false,
                    independentRefundSuccess: false,
                    cardVerificationSuccess: false,
                    batchCloseSuccess: false,
                    openTotalsSuccess: false,
                }

            case RESET_CONFIGURATION:
                return { ...state, config: initialState.config }
    
    
            default:
                return state
        }
    }
    else {
        return state
    }
}